import { graphql } from 'gatsby';
import { Layout, Code, Showcase, Header } from "../../../../src/components";
import "../../../../src/pages/wt/utilities/(deprecated) float/style.scss";
import data from "../../../../src/pages/wt/utilities/(deprecated) float/data.json";
import changelog from "../../../../src/data/changelog.json";
import * as React from 'react';
export default {
  graphql,
  Layout,
  Code,
  Showcase,
  Header,
  data,
  changelog,
  React
};